import React from 'react'

const Button = ({ text, variant, size, onClick }) => {
    return (
        <button className={`btn ${variant} ${size}`} onClick={onClick}>
            {text}
        </button>
    )
}

export default Button
